<template>
  <div class="product-suggestions">
    <div v-if="!loading" class="pb-5">
      <div v-if="similarProducts.length">
        <div class="font-weight-medium pa-3">{{ suggestionText }}</div>
        <v-row no-gutters>
          <v-col v-for="(productIndex, index) in productsToShow" v-if="productIndex <= totalProducts" :key="index"
            class="pa-2" cols="6" lg="3" md="4" sm="4" xl="3" xs="6">
            <B2CItemCard @clickButton="addBtnAction(similarProducts[productIndex - 1])"
              @clickCard="goToProductDetails(similarProducts[productIndex - 1])"
              :id="similarProducts[productIndex - 1].idBase64" :title="similarProducts[productIndex - 1].title" type="P"
              :imageUrl="similarProducts[productIndex - 1].imgUrl" :subtitle="similarProducts[productIndex - 1].brandName"
              :price="productPrice(similarProducts[productIndex - 1])"
              :stockAmount="similarProducts[productIndex - 1].onlineStock"
              :campaignValue="similarProducts[productIndex - 1].bestCampaign && similarProducts[productIndex - 1].bestCampaign.benefitRule === 2 ? 0 : discountPrice(similarProducts[productIndex - 1])"
              :campaignText="campaignText(similarProducts[productIndex - 1])"></B2CItemCard>
          </v-col>
        </v-row>
      </div>
    </div>
    <div v-else class="mx-auto mt-8 text-center">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import B2CItemCard from "@fixit/v-b2c-item/src/B2CItemCard.vue";

import { waitFor } from "vue-wait";

export default {
  name: "product-suggestions",
  components: {
    B2CItemCard
  },
  mixins: [webshopMixins],
  props: ["suggestionText", "suggestionsFor", "static", "product"],
  data() {
    return {
      windowSize: { x: window.innerWidth, y: window.innerHeight },
      productsToShow: 4,
    };
  },
  methods: {
    getSuggestions() {
      if (!this.product) return;
      waitFor(`loading webshopCore getSugestedProducts`, async function () {
        await this.$store.dispatch("webshopCore/getProductSuggestions", {
          productIds: [
            {
              productGuid: this.product.id,
              productId: this.product.odinProductId,
            },
          ],
          count: 10,
          chainId: this.currentChainId,
          applicationNumber: 5,
        });
      }).apply(this);
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    openSalonSelectDialog(product) {
      this.$store.dispatch("webshop/set", {
        key: "selectedProduct",
        value: product,
      });
      this.$store.dispatch("webshop/set", {
        key: "salonPickOptions",
        value: { dialog: true },
      });
    },
    addBtnAction(product) {
      this.$store.dispatch("webshop/set", {
        key: "addedToCartDialog",
        value: false,
      });
      if (this.salons.length === 1) {
        this.$store.dispatch("webshop/set", {
          key: "selectedProduct",
          value: product,
        });
        this.addProductToSalonCart(this.salons[0]);
      } else {
        this.openSalonSelectDialog(product);
      }
    },
    productDiscount(product) {
      if (product.discounts.length) {
        let discount = product.discounts[0]
        return Math.round(
          ((discount.OriginalPrice - discount.DiscountPrice) /
            discount.OriginalPrice) *
          100
        );
      }
      return Math.round(
        ((product.productDetails.price - product.salePrice) /
          product.productDetails.price) *
        100
      );
    },
    productPrice(product) {
      if (product.discounts.length) {
        return product.discounts[0].OriginalPrice;
      } else {
        return product.salePrice === 0 ? product.productDetails.price : product.salePrice;
      }
    },
    discountPrice(product) {
      if (product.discounts.length) {
        return Math.min(product.discounts.map((x) => x.DiscountPrice));
      } else return undefined;
    },
    campaignText(product) {
      if (product.bestCampaign) {
        if (product.bestCampaign.PromotionType === 1) {
          //BUNDLE
          return "";
        } else if (product.bestCampaign.PromotionType === 3) {
          return "Nyhet";
        } else {
          switch (product.bestCampaign.BenefitRule) {
            case 0:
              return product.PromotionType !== 1
                ? product.bestCampaign.AdditionalValue + "%"
                : "";
            case 1:
              return (
                product.bestCampaign.BenefitQty +
                " for " +
                product.bestCampaign.BenefitValue1
              );
            case 2:
              return (
                product.bestCampaign.BenefitQty +
                " for " +
                product.bestCampaign.BenefitValue1
              );
            default:
              return "";
          }
        }
      } else {
        return "";
      }
    },
  },
  computed: {
    similarProducts() {
      return this.$store.getters["webshopCore/getSugestedProducts"];
    },
    totalProducts() {
      return this.similarProducts.length;
    },
    loading() {
      return this.$wait.is("loading webshopCore getSugestedProducts");
    },
  },
  watch: {
    product() {
      if (!this.static) this.getSuggestions();
    },
  },
  created() {
    this.getSuggestions();
  },
};
</script>

<style lang="scss" scoped>
.v-slide-group::v-deep {
  .v-slide-group__content {
    place-content: center;
  }
}

.product-suggestions::v-deep {
  .v-btn {
    // padding: 18px 15px !important;
    height: 42px !important;
  }
}

.product-discount-tag {
  position: absolute;
  top: 0px;
  left: 0px;
  color: #ffffff;
  z-index: 1;
}
</style>
